module.exports = __webpack_public_path__ + "img/Weapon_299.b502be44.png";